import { useRef, useState, useEffect } from "react";

import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import "reactjs-popup/dist/index.css";

import EmailIcon from "@mui/icons-material/Email";
import SaveIcon from "@mui/icons-material/Save";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import Title from "../layout/Title";

import TextField from "@mui/material/TextField";

import LockIcon from "@mui/icons-material/Lock";

import BadgeIcon from "@mui/icons-material/Badge";

const UserSingle = () => {
  const [userId, setUserId] = useState(0);

  const axiosPrivate = useAxiosPrivate();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({pwd: ""});

  let { id } = useParams();

  useEffect(() => {
    console.log("id", id);

    if (id != undefined) {
      let isMounted = true;
      const controller = new AbortController();

      const getUser = async () => {
        try {
          const response = await axiosPrivate.get(`/users/${id}`, {
            signal: controller.signal,
          });
  
          const data = response.data;
          console.log("data", data);
  
          if (isMounted) {
            setValue("email", data["email"]);
            setValue("username", data["username"]);
            setValue("password", "");
  
            
            const roleKey = Object.keys(data.roles)[0]; 
            setValue("roles", roleKey);
  
            setUserId(data._id);
          }
        } catch (err) {
          console.error(err);
        }
      };

      getUser();

      return () => {
        isMounted = false;
        controller.abort();
      };
    }
  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/admin/users";

  const [errMsg, setErrMsg] = useState("");

  const errRef = useRef();

  console.log(errors);
  //console.log(watch("example"));

  const onSubmit = async (data) => {
    console.log("userId", userId);
  
    try {
      let response = {};

      // Mapeo de rol a objeto antes de enviarlo al backend
      const roleObject = {
        Admin: { Admin: 1950 },
        User: { User: 2022 },
        Support: { Support: 1985 },
        Contractor: { Contractor: 2025 },
      }[data.roles];

      // Transformar los datos para que coincidan con los nombres esperados por el backend
      const payload = {
        user: data.username, // Cambiar "username" a "user"
        email: data.email,
        pwd: data.password, // Cambiar "password" a "pwd"
        roles: roleObject, // Asegurar un valor por defecto para roles
      };

      console.log("Payload enviado:", payload);
  
      if (userId === 0) {
        console.log("Datos finales enviados:", payload);
        response = await axiosPrivate.post("/register", JSON.stringify(payload), {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        });
      } else {
        response = await axiosPrivate.put(
          `users/${userId}`,
          JSON.stringify(payload),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
      }
  
      navigate(from, { replace: true });
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Faltan datos obligatorios (Username o Password)");
      } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        setErrMsg("Error al Crear el Usuario");
      }
      errRef.current.focus();
    }
  };

  return (
    <Paper elevation={6} sx={{ p: 3, mb: 3 }}>
      <Title>{userId ? "Editar " : "Nuevo "}Usuario</Title>

      <p
        ref={errRef}
        className={errMsg ? "errmsg" : "offscreen"}
        aria-live="assertive"
      >
        {errMsg}
      </p>

      <br />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} lg={6}>
            <Box sx={{ display: "flex", alignItems: "flex-end" }}>
              <BadgeIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
              <TextField
                autoComplete="off"
                label="Nombre"
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant="standard"
                required
                {...register("username", { required: true })}
              />
              <small>{errors.username?.message}</small>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", alignItems: "flex-end" }}>
              <EmailIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
              <TextField
                label="Correo"
                variant="standard"
                fullWidth
                autoComplete="off"
                required
                {...register("email", {
                  required: true,
                  pattern: /^\S+@\S+$/i,
                })}
                InputLabelProps={{ shrink: true }}
              />
              <small>{errors.email?.message}</small>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", alignItems: "flex-end" }}>
              <LockIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
              <TextField
                label="Contraseña"
                variant="standard"
                type="password"
                name="password"
                autoComplete="off"
                {...register("password")}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <small>{errors.password?.message}</small>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth variant="standard">
              <InputLabel id="role-select-label">Rol</InputLabel>
              <Select
                labelId="role-select-label"
                id="roles"
                value={watch("roles") || ""}
                onChange={(e) => {
                  setValue("roles", e.target.value, { shouldValidate: true });
                }}
              >
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="User">User</MenuItem>
                <MenuItem value="Support">Soporte</MenuItem>
                <MenuItem value="Contractor">Contratista</MenuItem>
              </Select>
              <small>{errors.roles?.message}</small>
            </FormControl>
          </Grid>

          <Grid item xs={12} sx={{ marginTop: 3 }}>
            <Button type="submit" variant="contained" endIcon={<SaveIcon />}>
              Guardar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default UserSingle;
